<template>
  <div class="style-quiz-back-wrapper">
    <div class="style-quiz-back">
      <button class="prev" @click="exitStyleQuiz">
        <img
          src="@/assets/icons/left.svg"
          :alt="$t('project_details.proposal.slider_arrow_left_alt')"
        />
        <span>{{ $t("style_quiz.go_back") }}</span>
      </button>
    </div>
  </div>

  <create-project-steps-menu :current-step="3"></create-project-steps-menu>

  <div class="furniture loader-block-parent">
    <div v-show="loading" class="loader-block">
      <div>
        <div class="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
    <div class="furniture__left">
      <p class="furniture__heading">
        {{ $t("style_quiz.furnitures.select_furnitures") }}
      </p>
      <p class="furniture__subheading">
        {{ $t("style_quiz.furnitures.select_furnitures_desc") }}
      </p>
      <button
        class="furniture__button"
        v-for="roomKey in Object.keys(userRooms)"
        :class="{
          active: activeRoom === roomKey,
        }"
        @click.prevent="activeRoom = roomKey"
      >
        <div>{{ userRooms[roomKey].room.name }}</div>
      </button>
    </div>
    <div class="furniture__right">
      <div
        class="furniture__item"
        v-for="furn in activeFurniture"
        :class="{
          active: furn.isActive,
        }"
        @click.prevent="
          furn.isActive = !furn.isActive;
          furn.amount == 0 ? furn.amount = 1 : ''
        "
      >
        <div
          class="indicator"
          :class="{
            checked: furn.isActive,
          }"
        ></div>
        <div class="furniture__item-top">
          <img
            :src="furn.imagePath"
            :alt="furn.name"
          />
        </div>
        <div class="furniture-item__bottom">
          <div>{{ furn.name }}</div>
          <div class="control control--input control-number">
            <div>
              <button
                type="button"
                data-type="dec"
                @click.stop="
                  furn.amount > 0 &&
                    furn.amount--
                "
              >
                -
              </button>
              <input
                class="amount-input"
                placeholder="0"
                min="0"
                type="number"
                v-model="furn.amount"
                @click.stop=""
                @keydown="removeDecimal($event,furn)"
              />
              <button
                type="button"
                data-type="inc"
                @click.stop="furn.amount++"
              >
                +
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="buttons">
    <button @click.prevent="goBack" class="back">
      {{ $t("style_quiz.furnitures.prev") }}
    </button>
    <button
      class="next"
      @click.prevent="submitFurnitures"
      :class="{ disabled: sendingForm }"
      :disabled="sendingForm"
    >
      <template v-if="!sendingForm">
        {{ $t("style_quiz.furnitures.next") }}
      </template>
      <template v-else> {{ $t("style_quiz.furnitures.next") }}... </template>
    </button>
  </div>
</template>

<script>
import CreateProjectStepsMenu from "@/components/createProject/CreateProjectStepsMenu";
import { inject, ref } from "vue";
import { useI18n } from "vue-i18n";
import AlertHelper from "@/helpsers/alert.helper";
import axios from "axios";
import ApiHelper from "@/helpsers/api.helper";
import authHelper from "@/helpsers/auth.helper";
import { useFurnitures } from "./useFurnitures";
import { useRoute, useRouter } from "vue-router";
export default {
  name: "CreateProjectFurnitures",
  components: { CreateProjectStepsMenu },
  setup: function () {
    let sendingForm = ref(false);
    let alert = inject("alert");
    const { t } = useI18n();

    const route = useRoute();
    const router = useRouter();

    const {
      loading,
      fetchClientRooms,
      userRooms,
      activeRoom,
      activeFurniture,
      mapRoomsWithFurnitureForRequest,
    } = useFurnitures(route.params.id);
    fetchClientRooms();

    const submitFurnitures = async () => {
      try {
        sendingForm.value = true;
        const roomsWithFurnitures = mapRoomsWithFurnitureForRequest();
        roomsWithFurnitures.forEach((room) => {
          if (room.furnitures.length === 0) {
            throw new Error("select-all");
          }
        });
        await axios.put(
          ApiHelper.addManyRoomsWithFurnituresAmountUrl(route.params.id),
          {
            roomsWithFurnitures,
          },
          { headers: authHelper.authHeader() }
        );
        router.push({
          name: "create-project-deadline",
          params: { id: route.params.id },
        });
      } catch (error) {
        if (error?.message === "select-all") {
          return AlertHelper.show(
            alert,
            t("style_quiz.furnitures.select_furnitures"),
            "",
            "info"
          );
        }
        let errorMessage = ApiHelper.getResponseMessage(response?.data?.code);
        AlertHelper.show(alert, errorMessage, "", "error");
      } finally {
        sendingForm.value = false;
      }
    };

    function goBack() {
      router.back();
    }
    function exitStyleQuiz() {
      router.push({
        name: "project-details",
        params: { id: router.currentRoute.value.params.id, activeTab: 'styleQuiz'},
      });
    }

      function removeDecimal(e, roomId) {
          const key = e.key;

          if (key === '.' || key === ',')
              return e.preventDefault();
      }

    return {
      goBack,
      submitFurnitures,
      sendingForm,
      ApiHelper,
      exitStyleQuiz,
      userRooms,
      activeRoom,
      activeFurniture,
      loading,
      removeDecimal
    };
  },
};
</script>

<style scoped lang="scss">
@use "@/css/quiz";
@use "@/css/custom-quiz";

.furniture {
  &__right {
    max-height: 472px;
    overflow: auto;

    .indicator {
      &.checked {
        background-color: #f4f3f3;
        border: 0;
        background-image: url("./../../assets/icons/checkmark-dark.svg");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 70%;
      }
    }
  }

  &__button {
    width: 280px;
    min-height: 70px;
    height: auto;
    overflow: auto;
    display: flex;
    gap: 5px;

    @media screen and (max-width: 360px) {
      max-width: 100%;
    }
  }

  @media screen and (max-width: 867px) {
    flex-wrap: wrap;
  }
  &__left {
    @media screen and (max-width: 867px) {
      width: 100%;
    }
  }
}
.furniture-item {
  &__bottom {
    text-align: center;
    display: flex;
    flex-direction: column;
  }
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type=number] {
    -moz-appearance: textfield;
}
</style>
